<template>
  <v-container fluid :class="{ 'height': dialog ? '100%' : '' }">
    <v-row>
      <v-col xs12 md8 offset-md2>
        <v-card class="grey lighten-4 elevation-0">
          <v-toolbar>
            <v-toolbar-title>加入會員</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>帳號</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="username"
                    name="input-1-5"
                    label="e-mail"
                    v-model="user.username"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>密碼</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="password"
                    name="input-2-5"
                    label="密碼"
                    type="password"
                    class="input-group"
                    v-model="user.password"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>密碼確認</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    name="input-3-5"
                    label="密碼確認"
                    type="password"
                    value=""
                    class="input-group"
                    v-model="password_confirm"
                    v-bind:rules="[() => { return user.password !== password_confirm ? '與密碼不一致' : true}]"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>姓名</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="realname"
                    name="input-4-5"
                    label="姓名"
                    value=""
                    v-model="user.realname"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader>聯絡電話</v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-text-field
                    ref="phone"
                    name="input-5-5"
                    label="聯絡電話"
                    value=""
                    class="input-group"
                    v-model="user.phone"
                    required
                    single-line
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row row>
                <v-col sm4 hidden-sm-and-down>
                  <v-subheader></v-subheader>
                </v-col>
                <v-col sm8 xs12>
                  <v-checkbox
                    :label="'我同意 LiveABC會員條款'"
                    v-model="agree"
                    :disabled="true"
                    v-on:click.native="dialog = true"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>

            <v-card-row actions class="mt-4">
              <v-btn small primary dark v-on:click.native="validation()">註冊</v-btn>
            </v-card-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="70%">
      <v-btn slot="activator" color="primary" dark v-if="false">LiveABC會員條款</v-btn>
      <v-card style="padding: 1em; position: relative; padding-bottom: 5em; overflow: hidden;">
        <v-card-title class="text-xs-center">
          <span class="headline">「希伯崙股份有限公司」所屬網站(LiveABC互動英語教學集團)會員服務條款</span>
        </v-card-title>
        <v-card-text ref="agreement" style="height: 40vh; overflow-y: auto;" v-on:scroll="scroll">
          <h5>一、認知與接受條款</h5>
          <p>
          「希伯崙股份有限公司」(以下稱本公司)所經營之網站及軟體，包含「LiveABC互動英語教學集團」網站、「Live互動美語」、「遊臺中學英語APP」、「遊新北學英語APP」會員服務(以下稱LiveABC互動英語教學集團)，將依據本會員服務服務條款（以下稱本服務）提供相關服務內容。當您完成LiveABC互動英語教學集團會員註冊手續、或開始使用本服務時，即表示您已閱讀、瞭解並同意接受本服務條款之所有內容，並完全接受本服務現有與未來衍生的服務項目及內容。本公司有權於任何時間修改或變更本服務條款之內容，修改後的服務條款內容將公佈於LiveABC互動英語教學集團網站上，本公司將不會個別通知會員，建議會員隨時注意本服務之修改或變更內容。如會員於任何修改或變更後繼續使用本服務者，視為會員已閱讀、瞭解並同意接受該等修改或變更。若會員不同意上述的服務條款修訂或更新方式，或會員所屬的國家或地域排除本會員服務條款內容之全部或一部，或不接受本服務條款的任一約定時，會員應立即停止使用本服務。<br>
          若您為未滿二十歲，除應收受上述條款外，並應於您的家長（或監護人）閱讀、瞭解並同意本會員服務條款之所有內容及其後修改變更後，方得使用或繼續使用本服務。當您使用或繼續使用本服務時，即表示您的家長（或監護人）已閱讀、瞭解並同意接受本會員服務條款之所有內容及其後修改變更。<br>
          於提供網路購物、行銷推廣、物流服務、帳務服務、客戶管理及服務或其他合於營業登記項目或章程所訂業務需要之目的之範圍內，本公司將藉由加入會員或進行交易之手續，蒐集、處理、及利用您的個人資料，包括姓名、性別、生日、教育、職業、地址、e-mail、連絡方式、信用卡號等，並對您發送活動訊息、商品優惠訊息、廣告等相關服務。為了確保會員之個人資料、隱私及消費者權益之保護，依個人資料保護法規定告知以下事項，本公司將以電郵、傳真、電話、簡訊或其他通知公告方式利用您所提供之資料（資料類別C001、C002、C003、C011等各項類別相關資料）。利用對象除本公司外，亦可能包括相關服務的協力機構。<br>
          您同意於下列情形發生時，得依法公開您的個人資訊：<br>

          (1) 法律明文規定。<br>
          (2) 為維護國家安全或增進公共利益。<br>
          (3) 為免除當事人之生命、身體、自由或財產上之危險。<br>
          (4) 為防止他人權益之重大危害。<br>

          您得自由選擇提供之個人資料，若您提供之資料不正確、不完整或未隨時更正或補充，可能會無法收到刊物、優惠活動訊息等。<br>
          會員有權對個人資料行使以下權利，包含查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除，如欲行使上述權利，可與本公司客服連絡進行申請。
          </p>

          <h5>二、會員遵守（注意）事項</h5>
          <p>
          您註冊為會員或於使用本服務之同時，遵守以下事項：<br>
          於本服務註冊表詢問事項，提供您本人正確、最新及完整的資料，且不得以第三人名義註冊為會員。每位會員僅能註冊及登錄一個帳號，不可重覆註冊及登錄。<br>
          為確保會員個人資料為正確、最新及完整，會員應維持並即時更新個人資料。<br>
          若會員有提供任何錯誤或不實資料、或未按指示提供資料、或欠缺必要資料、或有重覆註冊帳號等情事時，本公司有權暫停或終止會員所屬帳號之使用權限，並得拒絕會員繼續使用本服務之全部或一部。<br>
          會員須妥善保存自己的帳號及密碼，不得將密碼告訴第三者，甚或提供第三者使用。<br>
          會員的帳號、密碼及會員權益均僅供會員個人使用及享有，在任何情形下，不得以任何形式轉借、轉讓本服務予他人或與他人合用。<br>
          會員的密碼或帳號遭到盜用或有其他任何安全問題發生時，應立即通知本公司。<br>
          </p>

          <h5>三、隱私權聲明</h5>
          <p>
          會員資料依本公司「隱私權聲明」受到保護及規範，請參閱 <a href="http://www.liveabc.com/site/Online_Store/member/privacy.asp">隱私權聲明</a><br>
          </p>

          <h5>四、廣宣及電子報、EDM發送</h5>
          <p>
          會員同意本公司基於行銷目的，於會員註冊有效期間內，得不定期發送廣告印刷品、電子報或EDM至會員所登錄的地址或電子信箱帳號。當會員收到訊息後，如表示拒絕接受行銷時，本公司將停止繼續發送行銷訊息。
          </p>

          <h5>五、免責聲明</h5>
          <p>
          有關本公司所提供之各項會員或使用者服務，均以該服務當時之功能及現況提供使用，對於會員或使用者之特定需求，包括但不限於速度、安全性、可靠性、完整性、正確性及不會斷線和出錯等，本公司皆不負擔任何明示或默示之擔保責任。
          本公司並不擔保本服務之網頁、伺服器、網域等所傳送的電子郵件或其內容不會含有電腦病毒等有害物；亦不擔保郵件、檔案或資料之傳輸儲存均正確無誤不會斷線和出錯等，因各該郵件、檔案或資料傳送或儲存失敗、遺失或錯誤等所致之損害，應由會員或使用者自行評估並承擔風險，本公司一概不負賠償責任。
          會員使用本服務進行交易時，應依據本公司確認後之商品數量及價格機制進行，若本服務網站上所標售商品或服務，發生交易條件(包括但不限於價格、規格、內容說明、圖片)錯誤時，本公司仍得於下單後三工作日內拒絕該筆訂單。
          </p>

          <h5>六、第三方網站連結免責條款</h5>
          <p>
          您可能會於LiveABC互動英語教學集團網站中連結至其他業者經營的網站，但不表示本公司與該其它業者有任何關係。其他業者經營的網站均由該業者自行負責，不屬本公司控制及負責範圍內。對於您經由LiveABC互動英語教學集團網站連結或瀏覽之其他網站內容，您應於連結前自行斟酌與判斷該網站內容之合適性、有效性、正確性、完整性、及是否侵害他人權利，以免遭受損失，本公司對於該等損失不負任何賠償責任，如檢索到一些令您厭惡或不需要的網站，遇到此類情形時，本公司建議您不要瀏覽或儘速離開該等網站。
          </p>

          <h5>七、服務中斷或故障</h5>
          <p>
          本服務有時可能會出現中斷或故障等現象，或是服務設備進行必要之保養及施工時需暫時停止服務，或許將造成您使用上的不便、資料喪失、錯誤、遭人篡改或其他經濟上損失等情形。您於使用本服務時宜自行採取防護措施。本公司對於您因使用（或無法使用）本服務而造成的損害，不負任何賠償責任。
          </p>

          <h5>八、會員使用限制規範</h5>
          <p>
          您同意不將「本服務」作以下用途，否則本公司有權刪除資料或取消會員資格且不作任何賠償：<br>
          干擾或破壞「本服務」或與「本服務」相連線之伺服器和網路，或不遵守於本服務連線網路之規定或規範。<br>
          公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案於本服務上。<br>
          侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利。<br>
          違反依法律或契約所應負之保密義務。<br>
          冒用他人名義使用本服務。<br>
          傳輸或散佈電腦病毒。<br>
          從事不法或未經本公司授權之商業或廣告宣傳行為。<br>
          其他本公司有正當理由認為不適當之行為。<br>
          您了解一切的資訊、資料、文字、軟體、音樂、音訊、照片、圖形、視訊、信息或其他資料，無論其為公開張貼或私下傳送，均為提供者之責任。
          </p>

          <h5>九、智慧財產權保護</h5>
          <p>
          本服務所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由本公司或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若您欲引用或轉載前述軟體、程式或網站內容，必須依法取得本公司或其他權利人的事前書面同意。尊重智慧財產權是您應盡的義務，如有違反，您應對本公司負損害賠償責任，包括但不限於訴訟費用及律師費用等。
          </p>

          <h5>十、會員責任風險告知</h5>
          <p>
          由會員公開張貼或私下傳送的資訊、資料、文字、軟體、音樂、音訊、照片、圖形、視訊、信息或其他資料（以下稱「會員內容」），均由提供者自負責任。本公司無法控制經由本服務而張貼之「會員內容」，因此不保證其正確性、完整性或品質。您了解使用本服務時，可能會接觸到令人不快、不適當、令人厭惡之「會員內容」。在任何情況下，本公司均不為任何「會員內容」負責，包含但不限於任何錯誤或遺漏，以及經由本服務張貼、發送電子郵件或傳送而衍生之任何損失或損害。<br>
          您了解本公司並未針對「會員內容」事先加以審查，但本公司有權（但無義務）自行考量，拒絕或移除經由本服務提供之任何「會員內容」。在不限制前開規定之前提下，本公司及其指定人有權將違反本服務條款和令人厭惡之任何「會員內容」加以移除。您使用任何「會員內容」時，就前開「會員內容」之正確性、完整性或實用性之情形，您同意必須自行加以評估並承擔所有風險。
          </p>
        </v-card-text>
        <div style="position: absolute; bottom: 0; width: 100%; text-align: center;">
          <v-divider></v-divider>
          <v-btn color="green darken-1" flat="flat" v-on:click.native="agreement(false)">不同意</v-btn>
          <v-btn color="green darken-1" flat="flat" v-on:click.native="agreement(true)" :disabled="!isRead">同意</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'
  import api from '../api'

  export default {

    name: 'Register',

    data () {
      return {
        user: {
          username: '',
          password: '',
          realname: '',
          phone: ''
        },
        password_confirm: '',
        agree: false,
        dialog: false,
        isRead: false
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '註冊',
        link: '/order'
      })
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb',
        'setErrorMessage'
      ]),

      register () {
        var self = this
        api.Account.Register(this.user)
          .then((res) => {
            alert('註冊成功, 請開啟電子信箱中的驗證信，進行驗證。')
            self.$router.push('/login')
          })
          .catch((error) => {
            console.log(error)
          })
      },

      validation () {
        var valid = true
        var message = ''

        if (this.user.username === '' ||
            this.user.password === '' ||
            this.user.realname === '' ||
            this.user.phone === '') {
          message = '請輸入必填欄位'
          this.$refs.phone.focus()
          this.$refs.password.focus()
          this.$refs.realname.focus()
          this.$refs.username.focus()
          valid = false
        }

        if (this.user.password !== '' &&
          this.user.password !== this.password_confirm) {
          message = message.length > 0 ? message + '，' : ''
          message += '密碼與確認密碼不一致'
          this.$refs.password.focus()
          valid = false
        }

        if (!this.agree) {
          message = message.length > 0 ? message + '，' : ''
          message += '需同意會員條款'
          valid = false
        }

        if (valid) {
          this.register()
        } else {
          this.setErrorMessage(message)
          return false
        }
      },

      agreement (agree) {
        this.agree = agree || false
        this.dialog = false
      },

      scroll () {
        if (this.$refs.agreement && this.$refs.agreement.scrollHeight - this.$refs.agreement.scrollTop < this.$refs.agreement.offsetHeight + 30) {
          this.isRead = true
          return
        }

        this.isRead = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn--disabled {
    color: #ccc;
  }

  @media screen and (max-width: 768px) {
    .headline {
      font-size: 12px;
      line-height: 120%
    }
  }
</style>



// WEBPACK FOOTER //
// Register.vue?7d2ce96e